// ISO639 の言語コードでないと使えない
export const languages = [`en`, `ko`, `zh-cn`, `zh-tw`] as const;
export const defaultLanguage = "en";

// localeがlanguagesのうちのどれか取得する関数
export const isLocaleValid = (
  locale: string
): locale is (typeof languages)[number] => {
  return languages.includes(locale as (typeof languages)[number]);
};
